import clsx from "clsx";
import type { EventStatus } from "../types";

const CONFIG: Record<EventStatus, { label: string; className: string }> = {
  DRAFT: {
    label: "Draft",
    className: "bg-slate-100 text-slate-700 border border-slate-200 dark:bg-slate-700/60 dark:text-slate-300 dark:border-slate-600",
  },
  OPEN: {
    label: "Open",
    className: "bg-green-100 text-green-800 border border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-800",
  },
  CLOSED: {
    label: "Closed",
    className: "bg-amber-100 text-amber-800 border border-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-800",
  },
  COMPLETED: {
    label: "Completed",
    className: "bg-blue-100 text-blue-800 border border-blue-200 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-800",
  },
  CANCELLED: {
    label: "Cancelled",
    className: "bg-red-100 text-red-800 border border-red-200 dark:bg-red-900/40 dark:text-red-300 dark:border-red-800",
  },
};

export function EventStatusBadge({ status }: { status: EventStatus }): JSX.Element {
  const config = CONFIG[status];
  return <span className={clsx("badge", config.className)}>{config.label}</span>;
}
